export default "__VITE_ASSET__Dk4sdsEe__"